import { ErrorCode } from '@afterpaytouch/portal-api'
import { useTranslation } from 'next-i18next'
import { useOfferDetailPBI } from '../../../state'

const rejectedReasonCodeKey = (rejectedReasonCode: ErrorCode | undefined): string => {
  switch (rejectedReasonCode) {
    case ErrorCode.MaxActiveOrdersReached:
      return 'tooManyOrdersSubheading'
    case ErrorCode.AmountTooHigh:
      return 'accountLimitSubheading'
    case ErrorCode.OrderAmountTooHigh:
      return 'accountLimitSubheading'
    case ErrorCode.MerchantOrderAmountLimitExceeded:
      return 'merchantLimitSubheading'
    default:
      return 'genericSubheading'
  }
}

export const usePBIRejectedText = (): string => {
  const { t } = useTranslation()
  const offerDetailPBI = useOfferDetailPBI()

  return t(`consumerLending:paymentTypesB:${rejectedReasonCodeKey(offerDetailPBI?.rejectedReasonCode)}`, { interval: offerDetailPBI?.numberOfInstallments })
}
